import React from 'react';
import Registration from '../components/Registration';

function RegistrationPage() {
  return (
    <div>
      <Registration />
    </div>
  );
}

export default RegistrationPage;
